import React from 'react';
import ReactDOM from 'react-dom/client';
// import './assets/styles/bootstrap.custom.css';
import './assets/styles/index.css'
// import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import HomeScreen from './screens/HomeScreen';
import CategoryScreen from './screens/CategoryScreen';
import ProductScreen from './screens/ProductScreen';
import CartScreen from './screens/CartScreen';
// import CartScreen from './screens/FloatingCartIcon';
 import LoginScreen from './components/LoginScreen';
import RegisterScreen from './components/RegisterScreen';
import ShippingScreen from './screens/ShippingScreen';
import PaymentScreen from './screens/PaymentScreen';
import PlaceOrderScreen from './screens/PlaceOrderScreen';
import OrderScreen from './screens/OrderScreen';
import OrderAgainScreen from './screens/OrderAgainScreen';
import ProfileScreen from './screens/ProfileScreen';
import OrderListScreen from './screens/admin/OrderListScreen';
import ProductListScreen from './screens/admin/ProductListScreen';
import ProductEditScreen from './screens/admin/ProductEditScreen';
import UserListScreen from './screens/admin/UserListScreen';
import UserEditScreen from './screens/admin/UserEditScreen';
import PaymentSuccessScreen from './screens/PaymentSuccessScreen';
import PaymentFailureScreen from './screens/PaymentFailureScreen'; 
import SearchScreen from './screens/SearchScreen';
import store from './store';
import { Provider } from 'react-redux';
// import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import firebase from 'firebase/compat/app'
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import { LoadScript } from "@react-google-maps/api";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  // authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  // projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  // messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  // appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
firebase.initializeApp(firebaseConfig);
// const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
// const GOOGLE_MAPS_LIBRARIES = ["places"];


const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<App />}>
      
      <Route index={true} path='/' element={<HomeScreen />} />
      
      <Route path='/search/:keyword' element={<HomeScreen />} />
      <Route path='/page/:pageNumber' element={<HomeScreen />} />
      <Route
        path='/search/:keyword/page/:pageNumber'
        element={<HomeScreen />}
      />
      {/* <Route path='/product/:id' element={<ProductScreen />} /> */}
      <Route path="/product" element={<HomeScreen />} />
      <Route path="/product/:slug" element={<ProductScreen />} />
      

      <Route path='/cart' element={<CartScreen />} />
      <Route path='/login' element={<LoginScreen />} />
      <Route path='/register' element={<RegisterScreen />} />
      <Route path="/category/:categoryName" element={<CategoryScreen />} />
      <Route path="/search" element={<SearchScreen/>} />
      {/* Registered users */}
      <Route path='' element={<PrivateRoute />}>
        <Route path='/shipping' element={<ShippingScreen />} />
        <Route path='/payment' element={<PaymentScreen />} />
        <Route path='/placeorder' element={<PlaceOrderScreen />} />
        <Route path='/order/:id' element={<OrderScreen />} />
        <Route path='/order-again' element={<OrderAgainScreen />} />
        <Route path='/profile' element={<ProfileScreen />} />
        <Route path='/payment/success' element={<PaymentSuccessScreen />} />
        <Route path='/payment/failure' element={<PaymentFailureScreen />} />
      </Route>
      {/* Admin users */}
      <Route path='' element={<AdminRoute />}>
        <Route path='/admin/orderlist' element={<OrderListScreen />} />
        <Route path='/admin/productlist' element={<ProductListScreen />} />
        <Route
          path='/admin/productlist/:pageNumber'
          element={<ProductListScreen />}
        />
        <Route path='/admin/userlist' element={<UserListScreen />} />
        <Route path='/admin/product/:id/edit/:detailId' element={<ProductEditScreen />} />
        <Route path='/admin/user/:id/edit' element={<UserEditScreen />} />
      </Route>
      <Route path="*" element={<HomeScreen />} />
    </Route>
  )
  // ,
  //  {
  //   future: {
  //     v7_startTransition: true, // ✅ Enable transition batching
  //   },
  // }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        {/* <PayPalScriptProvider deferLoading={true}> */}
        {/* <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY} libraries={GOOGLE_MAPS_LIBRARIES}> */}
          <RouterProvider router={router} />
          {/* </LoadScript> */}
        {/* </PayPalScriptProvider> */}
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);
// Change unregister() to register() below.
serviceWorkerRegistration.register();
reportWebVitals();
